import {
  APP_SETTING_LOAD_CUSTOM_JS_CDNS_BEGIN,
  APP_SETTING_LOAD_CUSTOM_JS_CDNS_SUCCESS,
  APP_SETTING_LOAD_CUSTOM_JS_CDNS_FAILURE,
  APP_SETTING_LOAD_CUSTOM_JS_CDNS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadCustomJsCdns(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_CUSTOM_JS_CDNS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/custom-js-cdn`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_CUSTOM_JS_CDNS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_CUSTOM_JS_CDNS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadCustomJsCdnsError() {
  return {
    type: APP_SETTING_LOAD_CUSTOM_JS_CDNS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_CUSTOM_JS_CDNS_BEGIN:
      return {
        ...state,
        loadCustomJsCdnsPending: true,
        loadCustomJsCdnsError: null,
      };

    case APP_SETTING_LOAD_CUSTOM_JS_CDNS_SUCCESS:
      return {
        ...state,
        loadCustomJsCdnsPending: false,
        loadCustomJsCdnsError: null,
        projectDetail: {
          ...state.projectDetail,
          customJsCdns: action.data,
        },
      };

    case APP_SETTING_LOAD_CUSTOM_JS_CDNS_FAILURE:
      return {
        ...state,
        loadCustomJsCdnsPending: false,
        loadCustomJsCdnsError: action.data.error,
      };

    case APP_SETTING_LOAD_CUSTOM_JS_CDNS_DISMISS_ERROR:
      return {
        ...state,
        loadCustomJsCdnsError: null,
      };

    default:
      return state;
  }
}
